import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './add-edit-placement-scenario.redux';

const selectDomain = (state: RootState) => state?.placementMarginScenario || initialState;

export const selectAddPlacementMarginScenario = createSelector([selectDomain], state => state?.addScenario);
export const selectAddPlacementMarginExtention = createSelector([selectDomain], state => state?.addExtension);
export const selectPlacementMarginToolDetailsData = createSelector([selectDomain], state => state?.marginDetails);
export const selectPlacementMarginBookingPeriod = createSelector([selectDomain], state => state?.bookingPeriod);
export const selectSelectedPlacementMarginScenario = createSelector([selectDomain], state => state?.selectedScenario);
export const selectPlacementMarginShiftDetails = createSelector([selectDomain], state => state?.shiftDetails);
export const selectCurrentEditPlacementMarginScenarioDetails = createSelector(
  [selectDomain],
  state => state?.selectedEditScenario,
);
export const selectPlacementMarginGsaDetails = createSelector([selectDomain], state => state?.gsaCalculatedValues);
export const selectPlacementMarginScenarioModalState = createSelector([selectDomain], state => state?.scenarioModal);
export const selectPlacementMarginDeletedSplits = createSelector([selectDomain], state => state?.deletedSplits);
export const selectPlacementMarginScenarioCreateUpdateResponse = createSelector(
  [selectDomain],
  state => state?.scenarioCreateUpdateResponse,
);
//TODO set it on page load
export const selectedPlacementMarginDetail = createSelector([selectDomain], state => state?.selectedMarginDetail);
//export const selectScenariosTreeView = createSelector([selectDomain], state => state?.scenariosTreeView);
export const selectPlacementMarginSearchPlacement = createSelector(
  [selectDomain],
  state => state?.selectedSearchPlacement,
);
export const selectFeatchPlacementMarginScenarioCalculateState = createSelector(
  [selectDomain],
  state => state?.shouldFeatchScenarioCalculate,
);
export const selectPlacementMarginGroupUpdateInprogressState = createSelector(
  [selectDomain],
  state => state?.isGroupUpdateInprogress,
);
export const selectPlacementMarginOverTimeHourlyRates = createSelector(
  [selectDomain],
  state => state?.marginOverTimeHourlyRates ?? [],
);
export const selectPlacementMarginTreeViewSelectedBookingPeriod = createSelector(
  [selectDomain],
  state => state?.selectedTreeViewBookingPeriod,
);

export const selectPlacementMarginPageLoadStatus = createSelector(
  [selectDomain],
  state => state?.isPageLoaded ?? false,
);
export const selectPlacementMarginSaveTriggeredStatus = createSelector(
  [selectDomain],
  state => state?.isSaveTriggered ?? false,
);
export const selectPlacementMarginCancelTriggeredStatus = createSelector(
  [selectDomain],
  state => state?.isCancelTriggered ?? false,
);

export const selectPlacementMarginOrderIdModifiedConfirmationDialogStatus = createSelector(
  [selectDomain],
  state =>
    (state?.shouldShowOrderIdModifiedDialog ?? false) &&
    ((state?.selectedScenario?.isBaseDetailsModified ?? false) ||
      (state?.selectedScenario?.isOrderIdModified ?? false) ||
      (state?.selectedScenario?.isSkillSetModified ?? false)) &&
    state?.selectedScenario?.scenarioId > 0,
);

export const selectPlacementMarginOrderIdModifiedConfirmationStatus = createSelector(
  [selectDomain],
  state =>
    ((state?.selectedScenario?.isBaseDetailsModified ?? false) ||
      (state?.selectedScenario?.isOrderIdModified ?? false) ||
      (state?.selectedScenario?.isSkillSetModified ?? false)) &&
    state?.selectedScenario?.scenarioId > 0,
);

export const selectAddEditPlacementMarginScenarioModelData = createSelector(
  [selectDomain],
  state => state?.addEditScenarioModelData,
);

export const selectPeopleSoftValues = createSelector(
  [selectDomain],
  state => state?.peopleSoftValues ?? [],
);
